module.exports = __webpack_public_path__ + "img/131.8a62e55b.jpg";